import { InjectionToken } from '@angular/core';

export interface Icon {
  name: string;
  icon: string;
}

export interface StackedIcon {
  name: string;
  class: string;
  icons: string[]
}

export const SOFTLINE_ICONS = new InjectionToken<(Icon | StackedIcon)[]>('SOFTLINE_ICONS');

export function isIcon(icon: unknown): icon is Icon {
  return (icon as Icon)?.icon !== undefined;
}

export function isStackedIcon(icon: unknown): icon is StackedIcon {
  return (icon as StackedIcon)?.icons !== undefined;
}
